import React from 'react';

function Faculty() {
  return (
    <section style={{background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)', minHeight: '100vh', padding: '160px 0 80px 0'}}>
      <div className="container">
        <div style={{textAlign: 'center', marginBottom: '60px'}}>
          <h2 style={{fontSize: '4rem', color: '#92400e', fontWeight: 900, marginBottom: '20px'}}>Our Dedicated Faculty</h2>
          <p style={{fontSize: '1.4rem', color: '#78350f', maxWidth: '800px', margin: '0 auto'}}>Our team of 25+ experienced and passionate educators is committed to nurturing every student's potential and creating a positive learning environment.</p>
        </div>
        <div style={{background: 'white', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.2)'}}>
          <img src="/images/academics/faculty.svg" alt="Faculty Group Photo" style={{width: '100%', height: 'auto', display: 'block'}} />
        </div>
      </div>
    </section>
  );
}

export default Faculty;
